export default [
  {
    text: 'healthCheck.table.customerGroup',
    value: 'customerGroup',
  },
  {
    text: 'healthCheck.table.venues',
    value: 'venues',
    type: 'slot',
  },
  {
    text: 'healthCheck.table.lastRunAt',
    value: 'lastRunAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
  {
    text: 'healthCheck.table.status',
    value: 'status',
    type: 'slot',
  },
  {
    text: 'healthCheck.table.errorList',
    value: 'errorList',
    type: 'slot',
  },
];
